<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Device {{ (this.inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Device - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <!-- {{device}} -->
            <fieldset :disabled="$attrs.viewMode == true ? true: false">
                <div v-if="customFormMode == 1">
                    <!-- Normal -->
                    <!-- {{device}} -->
                    <base-input alternative="" label="Code" placeholder="" v-model="device.code" input-classes="form-control" />
                    <base-input alternative="" label="Name" placeholder="" v-model="device.name" input-classes="form-control" required />
                    <base-input alternative="" label="Machine No." placeholder="" v-model="device.machine_no" input-classes="form-control" required />
                    <!-- <base-input label="Site Assignment" required>
                        <a-cascader v-model="device.location_path" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect :disabled="selectDisabled"/>
                    </base-input> -->
                    <base-input label="Device Type" required>
                        <a-select
                            v-model="device.device_type_id"
                            style="width: 100%"
                            placeholder="Device type"
                            option-label-prop="label"
                            :disabled="selectDisabled"
                            >
                            <a-select-option v-for="item in deviceTypeData" :key="item.id" :value="item.id"  :label="item.code">
                                <span>{{item.code}} ({{item.name}})</span>
                            </a-select-option>
                        </a-select>
                    </base-input>
                    <base-input label="Device Sites">
                        <a-select
                            v-model="device.site_ids"
                            style="width: 100%"
                            mode="multiple"
                            placeholder="Device Sites"
                            option-label-prop="label"
                            :disabled="selectDisabled"
                            >
                            <a-select-option v-for="item in validSites" :key="item.id" :value="item.id"  :label="item.name">
                                <span>{{item.code}} ({{item.name}})</span>
                            </a-select-option>
                        </a-select>
                    </base-input>

                    <!-- <a-checkbox v-model="device.is_multiple_sites"><b>Enable tagging multiple sites to this device</b></a-checkbox> -->
                </div>
                <div v-if="customFormMode == 2">
                    <!-- Override -->
                    <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="device" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
                </div>
                <div v-if="customFormMode == 3">
                    <!-- Append -->
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="Basic" key="1">
                            <base-input alternative="" label="Code" placeholder="" v-model="device.code" input-classes="form-control" />
                            <base-input alternative="" label="Name" placeholder="" v-model="device.name" input-classes="form-control" required />
                            <base-input alternative="" label="Machine No." placeholder="" v-model="device.machine_no" input-classes="form-control" required />
                        </a-tab-pane>
                        <a-tab-pane tab="Custom Fields" key="2" forceRender>
                            <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="device" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </fieldset>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Device?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            this.deviceTypeData = await HTTPRequest.getRequest(this.endPoint + 'device_types' , null)
            this.validSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites' , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                this.selectDisabled = true
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0){
                var device_data = await HTTPRequest.getRequest(component_x.endPoint + 'devices/' + component_x.profileId, null)
                if(device_data == undefined){
                    component_x.$router.go()
                } else {
                    if(device_data["error"] == undefined){
                        device_data.location_path = JSON.parse(device_data.location_path)
                        component_x.device = device_data
                    } else {
                        this.errors = device_data["error"].split(",");
                    } 
                }
            } 
            
            // this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view?full=1'  , null)
            this.locationOptions = this.$attrs.locationOptions
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                errors: [],
                deviceTypeData: [],
                deviceType: null,
                isMultipleSites: false,
                customFormMode: 1,
                validSites: [],
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                device: {},
                formErrors: [],
                locationOptions: [],
                inputLocation: null,
                selectDisabled:false
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.device.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.device.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.device.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.device.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.device.name, 0, 50));
                this.errors.push(ValidateField.required('Device Type', this.device.device_type_id));
                // this.errors.push(ValidateField.required('Location', this.device.location_path));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {

                    this.device.name = this.device.name.trim()
                    try {
                        this.device.location_path = JSON.stringify(this.device.location_path)
                        this.device.site_id = JSON.parse(this.device.location_path).pop()
                    } catch (error) {}
                    this.device.site_id = secureStorage.getItem("defaultSiteId")
                    if (this.device.code != undefined)
                        this.device.code = this.device.code.trim()
                    this.device.status = 'A'
                    // this.device.account_app_wavelet_id = thi
                    var devicePayload = { device: this.device }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'devices', null, devicePayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    var device = this.device
                    device.name = this.device.name.trim()
                    try {
                        device.location_path = JSON.stringify(this.device.location_path)
                        device.site_id = JSON.parse(this.device.location_path).pop()
                    } catch (error) {}
                    device.site_id = secureStorage.getItem("defaultSiteId")

                    if (device.code != undefined)
                        device.code = this.device.code.trim()
                    
                    let status = (device.status == null) ?  "A" : device.status
                    device.status = status
                    var devicePayload = { device: device }
                    
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'devices/' + this.profileId, null, devicePayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>